import { render } from "./TrackerSettings.vue?vue&type=template&id=12d993fa"
import script from "./TrackerSettings.vue?vue&type=script&lang=js"
export * from "./TrackerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__